import { FC } from 'react';

export type TIconProps = {
    fillColor?: string;
    secondFillColor?: string;
    strokeColor?: string;
    height?: string;
    width?: string;
    onClick?: (event: React.MouseEvent<SVGElement>) => void;
    className?: string;
    text?: string;
    title?: string;
    desc?: string;
};

export const IconBannerError: FC<TIconProps> = ({
    width = '21',
    height = '21',
    onClick = () => {},
    className = '',
    fillColor = '',
}) => {
    return (
        <svg viewBox="0 0 21 21" className={className} width={width} height={height}>
            <g fill="none" fillRule="evenodd" stroke={fillColor ? fillColor : '#FF3200'}>
                <path d="M10.493.594L.54 20.327c-.084.17-.082.173.106.173h19.706c.18 0 .186-.01.105-.173L10.505.594c-.067-.134.056-.135-.012 0z" />
                <path d="M10.5 14.5v-6M10.5 17.5v-1" strokeLinecap="round" />
            </g>
        </svg>
    );
};

export const IconCircleX: FC<TIconProps> = ({
    width = '16',
    height = '16',
    className = '',
    fillColor = '#8F96A1',
    onClick = () => {},
}) => (
    <svg width={width} height={height} className={className} viewBox="0 0 16 16" onClick={onClick}>
        <g fill="none" fillRule="evenodd">
            <path d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" fill={fillColor} />
            <path
                d="M4.646 5.354a.5.5 0 1 1 .708-.708l5.863 5.864a.5.5 0 0 1-.707.707L4.646 5.354z"
                fill="#FFF"
                fillRule="nonzero"
            />
            <path
                d="M5.354 11.217a.5.5 0 1 1-.708-.707l5.864-5.864a.5.5 0 0 1 .707.708l-5.863 5.863z"
                fill="#FFF"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export const IconCirclelessX: FC<TIconProps> = ({
    width = '16',
    height = '16',
    fillColor = '#8F96A1',
    className = '',
    onClick = () => {},
}) => (
    <svg width={width} height={height} className={className} viewBox="0 0 16 16" onClick={onClick}>
        <g fill={fillColor} fillRule="evenodd">
            <path d="M4.6464 5.3536a.5.5 0 1 1 .7072-.7072l5.8636 5.8637a.5.5 0 0 1-.7071.7071L4.6464 5.3536z" />
            <path d="M5.3536 11.2172a.5.5 0 1 1-.7072-.7071l5.8637-5.8637a.5.5 0 0 1 .7071.7072l-5.8636 5.8636z" />
        </g>
    </svg>
);

export const IconCircleCheck: FC<TIconProps> = ({
    width = '16',
    height = '16',
    fillColor = '#8F96A1',
    className = '',
    onClick = () => {},
}) => (
    <svg width={width} height={height} className={className} viewBox="0 0 16 16" onClick={onClick}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M15 8c0 3.8664-3.1348 7-7 7-3.867 0-7-3.1336-7-7s3.133-7 7-7c3.8652 0 7 3.1336 7 7z"
                fill={fillColor}
            />
            <path
                d="M6.848 9.7662L4.8642 7.6574a.5.5 0 1 0-.7284.6852l2.3519 2.5a.5.5 0 0 0 .7303-.0022l2.3241-2.5 2.3241-2.5a.5.5 0 1 0-.7324-.6808L6.848 9.7662z"
                fill="#FFF"
            />
        </g>
    </svg>
);

export const IconCircleCheck2: FC<TIconProps> = ({ width = '59', height = '58' }) => (
    <svg width={width} height={height} viewBox="0 0 59 58" fill="none">
        <path
            d="M29.5443 46.4414C39.1698 46.4414 46.9729 38.6383 46.9729 29.0128C46.9729 19.3873 39.1698 11.5842 29.5443 11.5842C19.9188 11.5842 12.1157 19.3873 12.1157 29.0128C12.1157 38.6383 19.9188 46.4414 29.5443 46.4414Z"
            fill="#88EBBE"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M47.94 38.5571L48.4543 40.7771C48.4686 40.8343 48.5114 40.8771 48.5657 40.8886L50.7857 41.4028C50.94 41.44 50.94 41.66 50.7857 41.6943L48.5657 42.2085C48.5086 42.2228 48.4657 42.2657 48.4543 42.32L47.94 44.54C47.9028 44.6943 47.6829 44.6943 47.6486 44.54L47.1343 42.32C47.12 42.2628 47.0771 42.22 47.0229 42.2085L44.8028 41.6943C44.6486 41.6571 44.6486 41.4371 44.8028 41.4028L47.0229 40.8886C47.08 40.8743 47.1229 40.8314 47.1343 40.7771L47.6486 38.5571C47.6857 38.4028 47.9057 38.4028 47.94 38.5571Z"
            fill="#88EBBE"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.0419 4.57641L19.6391 7.15641C19.6534 7.22212 19.7048 7.27069 19.7705 7.28783L22.3505 7.88497C22.5305 7.92783 22.5305 8.18212 22.3505 8.22498L19.7705 8.82212C19.7048 8.8364 19.6562 8.88784 19.6391 8.95355L19.0419 11.5336C18.9991 11.7136 18.7448 11.7136 18.7019 11.5336L18.1048 8.95355C18.0905 8.88784 18.0391 8.83926 17.9734 8.82212L15.3934 8.22498C15.2134 8.18212 15.2134 7.92783 15.3934 7.88497L17.9734 7.28783C18.0391 7.27355 18.0876 7.22212 18.1048 7.15641L18.7019 4.57641C18.7448 4.39641 18.9991 4.39641 19.0419 4.57641Z"
            fill="#11A884"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.2613 40.3858L13.2762 44.7739C13.3006 44.8834 13.3882 44.971 13.4977 44.9953L17.8858 46.0102C18.1925 46.0808 18.1925 46.5164 17.8858 46.587L13.4977 47.6019C13.3882 47.6262 13.3006 47.7139 13.2762 47.8234L12.2613 52.2115C12.1908 52.5181 11.7551 52.5181 11.6845 52.2115L10.6696 47.8234C10.6453 47.7139 10.5577 47.6262 10.4482 47.6019L6.06007 46.587C5.75341 46.5164 5.75341 46.0808 6.06007 46.0102L10.4482 44.9953C10.5577 44.971 10.6453 44.8834 10.6696 44.7739L11.6845 40.3858C11.7551 40.0791 12.1908 40.0791 12.2613 40.3858Z"
            fill="#11A884"
        />
        <path
            d="M44.6803 13.8079C44.6803 14.2252 44.5646 14.6425 44.3158 15.018L29.1054 38.0113C28.741 38.5746 28.1348 38.9363 27.4656 38.9989C27.3885 39.0059 27.3184 39.0128 27.2413 39.0128C26.6491 39.0128 26.0815 38.7798 25.661 38.366L19.6273 32.3777C18.7548 31.5118 18.7548 30.1069 19.6273 29.2445C20.0618 28.8133 20.6399 28.5977 21.2146 28.5977C21.7892 28.5977 22.3499 28.8133 22.7949 29.2445L26.8839 33.3027L40.5877 12.5873C41.2639 11.5614 42.648 11.2763 43.6746 11.9474C44.3263 12.3717 44.6873 13.0811 44.6873 13.8079H44.6803Z"
            fill="#008363"
        />
    </svg>
);

export const IconCircleCheck3: FC<TIconProps> = ({ width = '88', height = '88', fillColor = '#000000' }) => (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M44 0.25C19.875 0.25 0.25 19.875 0.25 44C0.25 68.125 19.875 87.75 44 87.75C68.125 87.75 87.75 68.125 87.75 44C87.75 19.875 68.125 0.25 44 0.25ZM44 83.062C22.461 83.062 4.938 65.539 4.938 44C4.938 22.461 22.461 4.938 44 4.938C65.539 4.938 83.062 22.461 83.062 44C83.062 65.539 65.539 83.062 44 83.062ZM63.141 28.273L39.45 51.964L28.212 40.726C27.2979 39.8119 25.8136 39.8119 24.8995 40.726C23.9854 41.6401 23.9854 43.1244 24.8995 44.0385L37.7945 56.9335C38.2515 57.3905 38.8531 57.621 39.4507 57.621C40.0484 57.621 40.6499 57.3905 41.1069 56.9335L66.4549 31.5855C67.369 30.6714 67.369 29.1871 66.4549 28.273C65.5408 27.3589 64.0604 27.3589 63.1424 28.273H63.141Z"
            fill={fillColor}
        />
    </svg>
);

export const IconUnsupportedBrowser: FC<TIconProps> = ({
    width = '300',
    height = '240',
    onClick = () => {},
    className = '',
}) => {
    return (
        <svg width={width} height={height} viewBox={'0 0 300 240'}>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M249.649 191.535c3-2.39 75.135-50.488 31.204-93.316-24.134-23.527-81.246.549-94.363-15.857-11.912-14.898 7.833-70.348-36.334-74.34-69.702-6.3-106.287 16.563-134.305 67.48-5.101 9.27-46.32 88.26 74.662 65.545 5.075-.953 14.288-.026 17.446 5.408 9.367 16.115-28.377 39.19-36.42 50.136-9.323 12.69-18.263 30.827 5.155 34.6 40.927 6.595 128.764-4.45 172.955-39.656z"
                    stroke="#F1F7FB"
                    strokeWidth=".863"
                    fill="#F1F7FB"
                />
                <path
                    d="M66.248 217.001a2.156 2.156 0 01.156 4.308l-.154.005-31.347.013a2.156 2.156 0 01-.156-4.307l.154-.005L66.248 217zm17.235 0a2.156 2.156 0 01.16 4.307l-.153.006-8.909.013a2.156 2.156 0 01-.16-4.307l.154-.005 8.908-.014zm161.617-37.07l35.069.206a2.156 2.156 0 01.129 4.309l-.154.004-35.07-.206a2.156 2.156 0 01-.128-4.308l.154-.005zM9.175 179l57.659.5a2.156 2.156 0 01.117 4.308l-.154.005-57.66-.5a2.156 2.156 0 01-.116-4.309l.154-.004z"
                    fill="#4885AD"
                    fillRule="nonzero"
                />
                <path
                    d="M235.306 66H75.694C69.788 66 65 70.776 65 76.667v119.666C65 202.224 69.788 207 75.694 207h159.612c5.906 0 10.694-4.776 10.694-10.667V76.667C246 70.776 241.212 66 235.306 66z"
                    fill="#FFF"
                    fillRule="nonzero"
                />
                <path
                    d="M235.306 66C241.212 66 246 70.776 246 76.667v119.666c0 5.891-4.788 10.667-10.694 10.667H75.694C69.788 207 65 202.224 65 196.333V76.667C65 70.776 69.788 66 75.694 66zm6.384 28.371H69.309v101.962c0 3.44 2.736 6.244 6.156 6.364l.229.004h159.612c3.526 0 6.384-2.851 6.384-6.368V94.37zm-6.384-24.072H75.694c-3.526 0-6.384 2.851-6.384 6.368l-.001 13.406H241.69V76.667c0-3.44-2.735-6.244-6.155-6.364l-.229-.004z"
                    fill="#4885AD"
                    fillRule="nonzero"
                />
                <g transform="translate(77 77)" fill="#4885AD" opacity=".5">
                    <circle cx="3.45" cy="3.45" r="3.45" />
                    <circle cx="16.388" cy="3.45" r="3.45" />
                    <circle cx="29.326" cy="3.45" r="3.45" />
                </g>
                <path
                    d="M140.417 163.166c9.005-7.412 22.88-6.802 31.098 1.439a1.96 1.96 0 11-2.777 2.769c-6.785-6.804-18.377-7.314-25.829-1.18a1.96 1.96 0 01-2.492-3.028zM135.194 122c-4.48 0-8.194 3.605-8.194 8.194s3.605 8.194 8.194 8.194c4.48 0 8.194-3.605 8.194-8.194S139.673 122 135.194 122zm42.264 4.313c-4.48 0-8.194 3.605-8.194 8.194 0 4.48 3.606 8.194 8.194 8.194 4.48 0 8.194-3.606 8.194-8.194 0-4.589-3.714-8.194-8.194-8.194z"
                    fill="#4885AD"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};

export const MBLogo: FC<TIconProps> = ({
    width = '912',
    height = '192',
    onClick = () => {},
    className = '',
    fillColor = '#2d2d2d',
    title = '',
    desc = '',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 911.98 191.2">
            {title && <title>{title}</title>}
            {desc && <desc>{desc}</desc>}
            <path
                d="M161.59 86.51v63.45H137.9V95.39c0-20.73-7.19-28.34-22-28.34S92.63 77.84 92.63 97.29v52.66H68.94V95.38c0-20.73-6.98-28.34-21.57-28.34-16.07 0-23.69 10.79-23.69 30.24v52.66H0V46.74h23.69v15.23h.42c8.46-11.42 19.88-16.71 32.57-16.71 15.65 0 26.44 6.98 31.94 19.46 10.15-12.9 22.63-19.46 36.59-19.46 23.69 0 36.38 15.65 36.38 41.24Zm19.19 63.45h23.69V46.74h-23.69v103.22ZM192.62 0c-8.88 0-15.86 7.19-15.86 15.65s6.98 15.86 15.86 15.86 16.08-7.19 16.08-15.86S201.51 0 192.62 0Zm91.41 45.26c-13.54 0-25.8 5.08-34.47 16.71h-.42V46.74h-23.69v103.22h23.69V97.3c0-19.46 8.25-30.24 25.59-30.24 15.86 0 23.48 7.61 23.48 28.34v54.57h23.69V86.52c0-25.59-13.11-41.24-37.86-41.24ZM416.92 2.11h23.48v147.84h-22.63v-14.81h-.42c-7.4 11-18.61 16.5-33.42 16.5-28.55 0-50.13-20.94-50.13-52.88s21.57-53.51 49.92-53.51c13.54 0 25.17 4.44 32.78 14.17h.42V2.11Zm.85 96.24c0-20.09-11.21-31.73-30.03-31.73-16.5 0-29.82 12.27-29.82 31.73s12.27 31.73 29.61 31.73 30.25-10.58 30.25-31.73Zm148.89.42c0 31.94-21.57 52.88-50.13 52.88-14.8 0-26.01-5.5-33.42-16.5h-.42v14.81h-22.63V2.11h23.48v57.32h.42c7.61-9.73 19.25-14.17 32.78-14.17 28.34 0 49.92 22.42 49.92 53.51Zm-24.11-.42c0-19.46-13.33-31.73-29.82-31.73-18.82 0-30.04 11.63-30.04 31.73 0 21.15 12.27 31.73 30.25 31.73s29.61-13.11 29.61-31.73Zm141.64.25c-.02 31.28-22.43 53.05-54.15 53.05s-54.15-22.84-54.15-53.09 21.43-53.14 53.81-53.3c29.94-.14 54.5 23.4 54.48 53.34Zm-24.11-.04c0-19.67-13.11-32.99-30.03-32.99-17.98 0-30.03 14.38-30.03 32.99s12.27 32.57 30.03 32.57c16.71 0 30.03-13.32 30.03-32.57ZM776.57 2.11h23.48v147.84h-22.63v-14.81H777c-7.4 11-18.61 16.5-33.42 16.5-28.55 0-50.13-20.94-50.13-52.88s21.57-53.51 49.92-53.51c13.54 0 25.17 4.44 32.78 14.17h.42V2.11Zm.85 96.24c0-20.09-11.21-31.73-30.03-31.73-16.5 0-29.82 12.27-29.82 31.73s12.27 31.73 29.61 31.73 30.25-10.58 30.25-31.73ZM888.3 46.74v49.28c0 19.46-8.04 30.24-24.96 30.24-15.44 0-22.84-7.61-22.84-28.34V46.74h-23.69v60.49c0 25.59 12.9 41.24 37.22 41.24 13.32 0 26.23-5.5 33.84-16.29h.42v8.46c0 18.19-10.36 29.19-30.67 29.19-14.8 0-23.9-4.23-35.11-10.15l-5.71 20.73c11.63 6.98 26.65 10.79 42.09 10.79 38.49 0 53.09-23.48 53.09-55.84V46.74h-23.69Z"
                fill={fillColor}
            />
        </svg>
    );
};

export const PoweredByMBLogo: FC<TIconProps> = ({
    width = '1929',
    height = '247',
    onClick = () => {},
    className = '',
    fillColor = '#2d2d2d',
    title = '',
    desc = '',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 1929 247">
            {title && <title>{title}</title>}
            {desc && <desc>{desc}</desc>}
            <path
                d="M961.998 111.484v81.767h-30.529v-70.324c0-26.714-9.265-36.52-28.351-36.52-19.085 0-29.987 13.904-29.987 38.969v67.862h-30.529v-70.324c0-26.714-8.995-36.52-27.797-36.52-20.709 0-30.529 13.904-30.529 38.969v67.862h-30.529V60.233h30.529V79.86h.541c10.903-14.717 25.619-21.534 41.973-21.534 20.168 0 34.072 8.995 41.16 25.077 13.08-16.624 29.163-25.077 47.153-25.077 30.529 0 46.882 20.167 46.882 53.145l.013.013Zm24.73 81.767h30.532V60.233h-30.532V193.25ZM1001.99 0c-11.447 0-20.442 9.266-20.442 20.168s8.995 20.438 20.442 20.438c11.44 0 20.72-9.265 20.72-20.438 0-11.173-9.27-20.168-20.72-20.168Zm117.79 58.326c-17.44 0-33.24 6.546-44.42 21.533h-.54V60.233h-30.53V193.25h30.53v-67.862c0-25.078 10.63-38.97 32.98-38.97 20.44 0 30.26 9.807 30.26 36.521v70.324h30.53v-81.767c0-32.978-16.9-53.146-48.79-53.146l-.02-.025Zm171.26-55.607h30.26v190.519h-29.17v-19.086h-.54c-9.53 14.176-23.98 21.264-43.07 21.264-36.79 0-64.6-26.985-64.6-68.146 0-41.16 27.8-68.957 64.33-68.957 17.45 0 32.44 5.721 42.25 18.26h.54V2.72Zm1.09 124.023c0-25.89-14.44-40.89-38.7-40.89-21.26 0-38.42 15.812-38.42 40.89 0 25.078 15.81 40.89 38.15 40.89 22.35 0 38.99-13.635 38.99-40.89h-.02Zm191.88.541c0 41.161-27.8 68.146-64.61 68.146-19.07 0-33.52-7.088-43.06-21.264h-.55v19.086h-29.16V2.719h30.26v73.867h.54c9.81-12.539 24.81-18.26 42.24-18.26 36.53 0 64.34 28.892 64.34 68.957Zm-31.08-.541c0-25.078-17.17-40.89-38.42-40.89-24.26 0-38.72 14.987-38.72 40.89 0 27.255 15.82 40.89 38.99 40.89s38.15-16.895 38.15-40.89Zm182.53.322c-.02 40.31-28.9 68.365-69.78 68.365s-69.78-29.434-69.78-68.417c0-38.982 27.62-68.48 69.34-68.686 38.59-.18 70.24 30.155 70.21 68.738h.01Zm-31.07-.052c0-25.348-16.89-42.513-38.7-42.513-23.17 0-38.69 18.531-38.69 42.513 0 23.983 15.81 41.973 38.69 41.973 21.54 0 38.7-17.165 38.7-41.973ZM1754.5 2.719h30.26v190.519h-29.17v-19.086h-.54c-9.53 14.176-23.98 21.264-43.06 21.264-36.8 0-64.61-26.985-64.61-68.146 0-41.16 27.8-68.957 64.34-68.957 17.44 0 32.43 5.721 42.24 18.26h.54V2.72Zm1.09 124.023c0-25.89-14.44-40.89-38.69-40.89-21.27 0-38.43 15.812-38.43 40.89 0 25.078 15.81 40.89 38.16 40.89 22.34 0 38.98-13.635 38.98-40.89h-.02Zm142.89-66.51v63.507c0 25.078-10.36 38.97-32.16 38.97-19.9 0-29.44-9.807-29.44-36.521V60.233h-30.52v77.952c0 32.978 16.62 53.146 47.96 53.146 17.17 0 33.8-7.088 43.61-20.993h.54v10.902c0 23.441-13.35 37.617-39.52 37.617-19.08 0-30.8-5.451-45.25-13.08l-7.36 26.714c14.99 8.995 34.35 13.905 54.24 13.905 49.61 0 68.42-30.258 68.42-71.96V60.233h-30.53.01ZM0 193.302v-73.537h25.686c17.193 0 24.34 9.736 24.34 22.786 0 15.536-10.565 22.683-25.893 22.683H9.01v28.068H0Zm9.01-36.25h14.294c12.222 0 17.4-6.215 17.4-14.708 0-9.425-6.11-14.397-15.95-14.397H9.011v29.105ZM101.945 193.924c-21.44 0-36.975-15.536-36.975-37.39s15.536-37.494 36.975-37.494c20.612 0 36.665 15.018 36.665 37.494 0 22.372-16.053 37.39-36.665 37.39Zm0-8.493c15.226 0 27.24-11.911 27.24-28.897 0-17.09-12.014-29.001-27.24-29.001-15.95 0-27.55 12.325-27.55 29.001 0 16.571 11.6 28.897 27.55 28.897ZM171.773 193.302l-23.408-73.537h9.632l18.126 58.933h.207l16.572-58.933h9.839l16.468 58.83h.207l18.229-58.83h9.529l-23.511 73.537h-8.7l-16.986-60.383h-.207l-17.297 60.383h-8.7ZM264.319 193.302v-73.537h45.054v8.182H273.33v24.651h29.518v8.182H273.33v24.34h38.218v8.182h-47.229ZM330.375 193.302v-73.537h26.101c16.986 0 24.339 9.736 24.339 22.786 0 12.325-6.732 19.472-18.332 21.854l20.3 28.897h-10.771l-19.472-28.068h-13.154v28.068h-9.011Zm9.011-36.25h14.604c12.222 0 17.504-6.215 17.504-14.708 0-9.425-6.111-14.397-16.261-14.397h-15.847v29.105ZM401.489 193.302v-73.537h45.054v8.182H410.5v24.651h29.518v8.182H410.5v24.34h38.218v8.182h-47.229ZM467.545 193.302v-73.537h21.958c23.304 0 38.218 15.122 38.218 36.872 0 21.647-14.396 36.665-37.907 36.665h-22.269Zm9.011-8.182h12.74c17.918 0 29.104-11.911 29.104-28.483 0-16.779-11.6-28.69-28.794-28.69h-13.05v57.173ZM580.238 193.302v-73.537h24.029c14.293 0 23.718 5.386 23.718 17.918 0 7.147-3.728 13.983-11.703 16.779v.207c8.596 1.761 15.329 7.975 15.329 18.644 0 11.703-7.872 19.989-24.547 19.989h-26.826Zm9.011-41.843h15.122c7.561 0 14.396-3.108 14.396-12.015 0-7.043-4.66-11.6-15.432-11.6l-14.086.103v23.512Zm0 33.661h16.986c9.632 0 15.95-4.039 15.95-12.532 0-8.286-5.903-13.258-17.296-13.258h-15.64v25.79ZM666.325 193.302v-32.833l-24.962-40.704h10.358l19.057 31.59h.207l18.954-31.59h10.565l-25.168 40.704v32.833h-9.011Z"
                fill={fillColor}
            />
        </svg>
    );
};

export const IconFamily: React.SFC<TIconProps> = ({
    width = '96',
    height = '56',
    onClick = () => {},
    className = '',
    fillColor = '#0A7C8E',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 96 56">
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h96v56H0z" />
                <path
                    d="M52.74 41.5c14.418 0 21.065 3.515 21.065 14.5h-2.53c0-9.419-5.38-12-18.536-12h-8.188C31.376 44 25.72 46.595 25.72 56h-2.532c0-10.967 6.923-14.5 21.364-14.5h8.188zM52.454.447c.465.043.852.08 1.656.162 4.482.453 6.362.496 8.517-.01a1.266 1.266 0 011.535.971c1.04 5.168.996 9.119-.736 12.863.004.035.006.07.007.106.01.394.015.828.016 1.303.003.632 0 1.25-.008 2.101l-.008.877a22.47 22.47 0 01-.406 3.857c-1.575 7.853-7.637 14.14-14.528 14.14-7.895 0-14.934-9.227-14.934-18.005v-.927c0-.066.005-.13.015-.194v-.003l.002-.017h-.001c.224-7.97 2.612-13.758 8.638-16.265C45.092.211 47.983.041 52.455.447zM36.132 17.344l-.013.176-.007.221a1.533 1.533 0 01-.014.17l-.001.9c0 7.528 6.087 15.507 12.403 15.507 5.534 0 10.684-5.341 12.045-12.127.205-1.023.351-2.401.358-3.388l.008-.882c.005-.5.008-.917.009-1.304-4.054 1.57-8.758 1.026-14.567-2.14-5.358-2.92-9.888-1.01-10.221 2.867zm7.07-13.634c-3.353 1.395-5.358 4.163-6.345 8.074 2.666-1.636 6.643-1.718 10.719.504 5.637 3.072 9.782 3.353 13.3 1.618 1.562-3.047 1.773-6.3 1.033-10.62-2.03.31-4.12.208-8.055-.19a151.97 151.97 0 00-1.63-.16c-4.091-.371-6.629-.221-9.022.774z"
                    fill={fillColor}
                />
                <path
                    d="M20.378 32.85c9.468 0 13.834 3.25 13.834 10.542h-1.663c0-6.252-3.532-8.882-12.17-8.882h-5.377c-8.652 0-12.367 2.784-12.367 9.028H.973c0-7.28 4.546-10.687 14.029-10.687h5.376zM20.192 5.6c.305.028.56.053 1.087.107 2.943.3 4.178.33 5.593-.007a.831.831 0 011.008.645c.683 3.431.654 6.054-.484 8.54a.741.741 0 01.005.07c.006.261.01.549.01.864.003.42 0 .83-.004 1.395l-.006.582c-.005.761-.112 1.78-.266 2.56-1.034 5.214-5.016 9.387-9.54 9.387-5.185 0-9.807-6.125-9.807-11.952v-.615c0-.043.003-.086.01-.127h0v-.015c.148-5.292 1.716-9.134 5.673-10.798 1.886-.793 3.784-.906 6.72-.636zM9.479 16.746l-.013.157-.005.13.005-.13-.006.165v.01h0l-.01.111v.6c0 4.997 3.997 10.294 8.145 10.294 3.634 0 7.016-3.546 7.909-8.05.135-.68.23-1.594.235-2.25l.005-.585.006-.865c-2.661 1.041-5.75.68-9.565-1.421-3.487-1.921-6.44-.692-6.706 1.834zm4.637-8.981c-2.202.926-3.518 2.764-4.167 5.36 1.751-1.086 4.362-1.14 7.039.334 3.701 2.04 6.424 2.226 8.733 1.074 1.026-2.023 1.164-4.182.679-7.05-1.334.206-2.706.138-5.29-.126a98.747 98.747 0 00-1.07-.106c-2.686-.246-4.353-.147-5.924.514zM81.378 32.85c9.468 0 13.834 3.25 13.834 10.542h-1.663c0-6.252-3.532-8.882-12.17-8.882h-5.377c-8.652 0-12.367 2.784-12.367 9.028h-1.662c0-7.28 4.546-10.687 14.029-10.687h5.376zM81.192 5.6c.305.028.56.053 1.087.107 2.943.3 4.178.33 5.593-.007a.831.831 0 011.008.645c.683 3.431.654 6.054-.484 8.54a.741.741 0 01.005.07c.006.261.01.549.01.864.003.42 0 .83-.004 1.395l-.006.582c-.005.761-.112 1.78-.266 2.56-1.034 5.214-5.016 9.387-9.54 9.387-5.185 0-9.807-6.125-9.807-11.952v-.615c0-.043.003-.086.01-.127h0v-.015c.148-5.292 1.716-9.134 5.673-10.798 1.886-.793 3.784-.906 6.72-.636zM70.479 16.746l-.013.157a26.36 26.36 0 00-.005.13l.005-.13-.006.165v.01h0l-.01.111v.6c0 4.997 3.997 10.294 8.145 10.294 3.634 0 7.016-3.546 7.909-8.05.135-.68.23-1.594.235-2.25l.005-.585.006-.865c-2.661 1.041-5.75.68-9.565-1.421-3.487-1.921-6.44-.692-6.706 1.834zm4.637-8.981c-2.202.926-3.519 2.764-4.167 5.36 1.751-1.086 4.362-1.14 7.039.334 3.701 2.04 6.424 2.226 8.733 1.074 1.026-2.023 1.164-4.182.679-7.05-1.334.206-2.706.138-5.29-.126a98.747 98.747 0 00-1.07-.106c-2.686-.246-4.353-.147-5.924.514z"
                    stroke={fillColor}
                    strokeWidth=".65"
                    fill={fillColor}
                />
            </g>
        </svg>
    );
};

export const IconFamily2: React.FC<TIconProps> = ({
    width = '41',
    height = '31',
    onClick = () => {},
    className = '',
    fillColor = '#F21300',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 41 31" fill="none">
            <path
                d="M10.3333 2.58333C11.7542 2.58333 12.9167 3.74583 12.9167 5.16667C12.9167 6.5875 11.7542 7.75 10.3333 7.75C8.9125 7.75 7.75 6.5875 7.75 5.16667C7.75 3.74583 8.9125 2.58333 10.3333 2.58333ZM10.3333 15.5C13.8208 15.5 17.825 17.1663 18.0833 18.0833H2.58333C2.88042 17.1533 6.85875 15.5 10.3333 15.5ZM10.3333 0C7.47875 0 5.16667 2.31208 5.16667 5.16667C5.16667 8.02125 7.47875 10.3333 10.3333 10.3333C13.1879 10.3333 15.5 8.02125 15.5 5.16667C15.5 2.31208 13.1879 0 10.3333 0ZM10.3333 12.9167C6.88458 12.9167 0 14.6475 0 18.0833V20.6667H20.6667V18.0833C20.6667 14.6475 13.7821 12.9167 10.3333 12.9167Z"
                fill={fillColor}
            />
            <path
                d="M29.7083 12.9173C31.1292 12.9173 32.2917 14.0798 32.2917 15.5007C32.2917 16.9215 31.1292 18.084 29.7083 18.084C28.2875 18.084 27.125 16.9215 27.125 15.5007C27.125 14.0798 28.2875 12.9173 29.7083 12.9173ZM29.7083 25.834C33.1958 25.834 37.2 27.5002 37.4583 28.4173H21.9583C22.2554 27.4873 26.2337 25.834 29.7083 25.834ZM29.7083 10.334C26.8537 10.334 24.5417 12.6461 24.5417 15.5007C24.5417 18.3552 26.8537 20.6673 29.7083 20.6673C32.5629 20.6673 34.875 18.3552 34.875 15.5007C34.875 12.6461 32.5629 10.334 29.7083 10.334ZM29.7083 23.2507C26.2596 23.2507 19.375 24.9815 19.375 28.4173V31.0007H40.0417V28.4173C40.0417 24.9815 33.1571 23.2507 29.7083 23.2507Z"
                fill={fillColor}
            />
        </svg>
    );
};

export const IconCircleCheckMarkHollow: FC<TIconProps> = ({
    width = '32px',
    height = '32px',
    onClick = () => {},
    className = '',
    fillColor = '#5A5E66',
}) => (
    <svg width={width} height={height} onClick={onClick} className={className} viewBox="0 0 32 32">
        <defs>
            <path
                id="check-mark-a"
                d="M27.5,16 C27.5,9.64870263 22.3506788,4.5 16,4.5 C9.64729211,4.5 4.5,9.64760131 4.5,16 C4.5,22.3523987 9.64729211,27.5 16,27.5 C22.3506788,27.5 27.5,22.3512974 27.5,16 Z M28.5,16 C28.5,22.903609 22.9029367,28.5 16,28.5 C9.09499391,28.5 3.5,22.90467 3.5,16 C3.5,9.09533001 9.09499391,3.5 16,3.5 C22.9029367,3.5 28.5,9.09639099 28.5,16 Z M10.612291,17.0027207 C10.4379214,16.7885949 10.4701501,16.4736572 10.6842758,16.2992875 C10.8984015,16.1249179 11.2133393,16.1571465 11.387709,16.3712723 C12.0518209,17.186801 12.6771596,17.967359 13.263736,18.7129659 C14.1000315,19.7759947 14.5778384,19.7631461 15.5089948,18.6675206 C16.8146808,17.1312129 18.5183084,15.1337668 20.6199298,12.6751206 C20.7993558,12.4652136 21.1149725,12.4405039 21.3248794,12.6199298 C21.5347864,12.7993558 21.5594961,13.1149725 21.3800702,13.3248794 C19.279014,15.7828644 17.5759656,17.7796314 16.2709771,19.3151185 C14.9442082,20.876233 13.7191513,20.9091757 12.477798,19.3312712 C11.8947855,18.5901944 11.2729461,17.8140044 10.612291,17.0027207 Z"
            />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="check-mark-b" fill="#fff">
                <use xlinkHref="#check-mark-a" />
            </mask>
            <use fill={fillColor} fillRule="nonzero" xlinkHref="#check-mark-a" />
            <rect width="32" height="32" fill={fillColor} mask="url(#check-mark-b)" rx="3" />
        </g>
    </svg>
);

export const IconTrash: React.SFC<TIconProps> = ({
    width = '32',
    height = '32',
    onClick = () => {},
    className = '',
    fillColor = '#54575F',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <path
                    fill={fillColor}
                    d="M18.5026083 6C19.884391 6 21 7.11409479 21 8.5V10h4.5c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5l-.9999473-.0001524c-.0000196.0206052-.0013119.0414369-.0039438.0624092-.6278316 5.0030336-1.2557016 9.6728166-1.8836223 14.0093942C22.4218738 26.3880704 21.9103685 27 20.7058824 27h-9.4117648c-1.204242 0-1.71602073-.6121321-1.90660417-1.928349-.62792073-4.3365776-1.25579071-9.0063606-1.88362238-14.0093942L7.501 11H6.5c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5H11V8.5C11 7.11992375 12.1190802 6 13.4973917 6h5.0052166zM8.504 11l.14887572 1.1800386c.5748085 4.5296136 1.14958393 8.7790621 1.72431668 12.7483104.126865.8761611.2903062 1.071651.9169252 1.071651h9.4117648c.6268061 0 .790028-.1952674.9169252-1.071651.624333-4.3118003 1.2487164-8.954251 1.8731379-13.9273073L8.504 11zm9.996 4c.2761424 0 .5.2238576.5.5v6c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5v-6c0-.2761424.2238576-.5.5-.5zm-5 0c.2761424 0 .5.2238576.5.5v6c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5v-6c0-.2761424.2238576-.5.5-.5zm5.0026083-8h-5.0052166C12.6715337 7 12 7.67203988 12 8.5V10h8V8.5c0-.83331619-.6675899-1.5-1.4973917-1.5z"
                />
            </g>
        </svg>
    );
};

export const IconAddCircle: FC<TIconProps> = ({
    width = '72',
    height = '72',
    strokeColor = '#696C74',
    fillColor = '',
}) => {
    return (
        <svg width={width} height={height} viewBox={'0 0 72 72'}>
            <g fill="none" fillRule="evenodd">
                <circle
                    stroke={fillColor ? fillColor : strokeColor}
                    strokeWidth="3"
                    cx="36"
                    cy="36"
                    r="32.217"
                    fill={fillColor ? fillColor : 'none'}
                />
                <g transform="translate(19 19)" fill={fillColor ? '#ffffff' : strokeColor}>
                    <rect x="15" width="3" height="33" rx="1.217" />
                    <path d="M33 16.217v.566c0 .672-.545 1.217-1.217 1.217H1.217A1.217 1.217 0 010 16.783v-.566C0 15.545.545 15 1.217 15h30.566c.672 0 1.217.545 1.217 1.217z" />
                </g>
            </g>
        </svg>
    );
};

export const IconBuilding: React.SFC<TIconProps> = ({ width = '48', height = '48', onClick = () => {} }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 48 48">
            <g stroke="#73757c" strokeWidth="1.5" fill="none" fillRule="evenodd">
                <path d="M43.021 10.252H4.75v31.516h38.271V10.252z" />
                <path d="M38.602 5.75H9.17v9.005h29.433V5.75zM22.4 22.258H9.168v15.008h13.23V22.258z" fill="#eff1f3" />
                <path strokeLinejoin="round" d="M27.568 41.714V21.508h10.76v20.227" />
            </g>
        </svg>
    );
};

export const IconClick: FC<TIconProps> = ({
    width = '56',
    height = '56',
    onClick = () => {},
    fillColor = '#696C74',
    strokeColor = '#696C74',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 56 56">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M29.941 19.5c.597 0 1.091.064 1.654.311 1.15.504 1.843 1.58 1.843 3.295v11.412c2.685.037 4.54.037 5.564 0 3.612.15 5.414 2.56 5.495 7.055l.003.31V49c0 .39-.165.586-.494.586-.33 0-.498-.195-.506-.586v-7.117c0-4.204-1.443-6.183-4.498-6.312H32.57c-.207 0-.165-.25-.165-.617v-.656l.033-11.202c0-1.31-.46-2.026-1.244-2.37-.406-.177-.784-.207-1.253-.226-1.661-.069-2.528.797-2.6 2.596v16.859c0 .642-.544.699-.961.466a3.496 3.496 0 01-.527-.39 40 40 0 01-1.252-1.19l-.783-.799a935.968 935.968 0 00-3.093-3.088c-1.227-1.142-2.291-1.272-3.332-.379-1.454 1.248-1.15 2.586.358 4.267l9.45 9.81c.313.308.36.577.14.809-.221.232-.508.194-.86-.114l-9.406-9.74c-2.04-2.156-2.263-4.001-.292-5.692 1.476-1.267 2.975-1.162 4.463.161l3.355 3.325 1.739 1.727V23.096c0-2.265 1.178-3.514 3.378-3.592l.223-.004z"
                    fill={strokeColor}
                />
                <path
                    d="M45 6c1.369 0 2.895 1.464 3 3v18c0 1.369-1.464 2.895-3 3h-8.402c-.395.009-.592-.156-.592-.493 0-.338.197-.507.592-.507H45c.825 0 1.91-1.032 2-2V10c0-1.825-1.032-2.91-2-3H8C6.175 7 5.09 8.032 5 9v18c0 .825 1.032 1.91 2 2H23.37c.417.009.626.178.626.507s-.209.493-.626.493H8c-2.369 0-3.895-1.464-4-3V10c0-2.369 1.464-3.895 3-4h38z"
                    fill={fillColor}
                />
                <path
                    d="M20.318 13.614a.5.5 0 01.068.704l-5.62 6.846c-1.44 1.76-2.761 1.797-4.107.02l-.79-1.036c-.406-.527-.826-1.07-1.263-1.626a.5.5 0 11.788-.617l.855 1.1c.279.36.55.713.815 1.06l.392.516c.904 1.193 1.45 1.225 2.418.091l5.74-6.99a.5.5 0 01.704-.068z"
                    fill={fillColor}
                />
            </g>
        </svg>
    );
};

export const IconQuestionCircle: FC<TIconProps> = ({
    width = '56',
    height = '56',
    onClick = () => {},
    strokeColor = '#696C74',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 56 56">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M49 28c0 11.6-9.404 21-21 21-11.601 0-21-9.4-21-21S16.399 7 28 7c11.596 0 21 9.4 21 21h0z"
                    stroke={strokeColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <g transform="translate(21 17)" fill={strokeColor}>
                    <path d="M1.5 6.75a.75.75 0 01-1.5 0C0 3 2.976 0 6.75 0c3.723 0 6.75 3.108 6.75 6.75 0 2.747-1.028 4.176-3.337 5.699l-.56.365C8.008 13.857 7.5 14.48 7.5 15.75a.75.75 0 11-1.5 0c0-1.91.805-2.899 2.782-4.191l.555-.362C11.267 9.924 12 8.905 12 6.75 12 3.927 9.636 1.5 6.75 1.5 3.807 1.5 1.5 3.825 1.5 6.75z" />
                    <circle cx="6.75" cy="21" r="1.125" />
                </g>
            </g>
        </svg>
    );
};

export const IconArrowLeft: FC<TIconProps> = ({
    width = '32px',
    height = '32px',
    fillColor = '#696C74',
    className = '',
    onClick = () => {},
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        version="1.1"
        fill={fillColor}
        fillRule="evenodd"
        onClick={onClick}
        className={className}
    >
        <g fill="none" fillRule="evenodd">
            <path
                fill={fillColor}
                d="M18.3665692,16 L11.6053239,7.30697031 C11.4357889,7.08899671 11.4750561,6.77485891 11.6930297,6.60532389 C11.9110033,6.43578887 12.2251411,6.4750561 12.3946761,6.69302969 L19.3946761,15.6930297 C19.535108,15.8735849 19.535108,16.1264151 19.3946761,16.3069703 L12.3946761,25.3069703 C12.2251411,25.5249439 11.9110033,25.5642111 11.6930297,25.3946761 C11.4750561,25.2251411 11.4357889,24.9110033 11.6053239,24.6930297 L18.3665692,16 Z"
                transform="matrix(-1 0 0 1 31 0)"
            />
        </g>
    </svg>
);

export const IconMailWoosh: FC<TIconProps> = ({
    width = '96',
    height = '48',
    className = '',
    fillColor = '#696C74',
    onClick = () => {},
}) => (
    <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 96 48">
        <g fill="none" fillRule="evenodd">
            <path d="M48 14.5H17.5M48 24.5H13.5M48 34.5H7.5" stroke={fillColor} strokeLinecap="square" />
            <path
                d="M59.006 17.8685s7.2866 5.8848 10.0116 8.1914c1.7813 1.5077 4.1852 1.4917 5.9587.005 3.1574-2.647 10.3068-8.4329 10.3068-8.4329"
                stroke={fillColor}
                strokeLinecap="round"
            />
            <path
                d="M54.75 18c0-4.6187 2.1012-6.75 6.75-6.75h21c4.6187 0 6.75 2.1012 6.75 6.75v12c0 4.6187-2.1012 6.75-6.75 6.75h-21c-4.6187 0-6.75-2.1012-6.75-6.75V18z"
                stroke={fillColor}
            />
        </g>
    </svg>
);

export const IconInfo: FC<TIconProps> = ({
    width = '13',
    height = '13',
    className = '',
    fillColor = '#696C74',
    onClick = () => {},
}) => (
    <svg width={width} height={height} viewBox="0 0 13 13">
        <path
            fill={fillColor}
            fillRule="evenodd"
            d="M6.5 0A6.5 6.5 0 0 1 13 6.5 6.5 6.5 0 1 1 6.5 0zM7 6H6v4h1V6zm-.5-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        />
    </svg>
);

export const IconRoundedWarning: FC<TIconProps> = ({
    width = '15px',
    height = '13px',
    onClick = () => {},
    className = '',
    fillColor = '#FF3200',
}) => (
    <svg width={width} height={height} onClick={onClick} className={className}>
        <defs>
            <path
                id="a-IconRoundedWarning"
                d="M9.3815 1.6454l5.8298 10.8824A1 1 0 0 1 14.3298 14H2.6702c-.5523 0-1-.4477-1-1a1 1 0 0 1 .1185-.4722L7.6185 1.6454c.2608-.4868.8669-.67 1.3537-.4092a1 1 0 0 1 .4093.4092zM8 9h1V5H8v4zm.5 3.5c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(-1 -1)">
            <mask id="b-IconRoundedWarning" fill="#fff">
                <use xlinkHref="#a-IconRoundedWarning" />
            </mask>
            <use fill="#5A5E66" xlinkHref="#a-IconRoundedWarning" />
            <g fill={fillColor} mask="url(#b-IconRoundedWarning)">
                <rect width="16" height="16" rx="3" />
            </g>
        </g>
    </svg>
);

export const IconSuccess: FC<TIconProps> = (props) => (
    <svg viewBox="0 0 102 102" width={props.width} height={props.height}>
        <path
            fill="none"
            stroke={props.fillColor ? `#${props.fillColor}` : '#42B145'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeMiterlimit="10"
            d="M72.8 37.4L43.7 66.5 29.2 51.9"
        />
        <path
            fill="none"
            stroke={props.fillColor ? `#${props.fillColor}` : '#42B145'}
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M51 1c27.6 0 50 22.4 50 50s-22.4 50-50 50S1 78.6 1 51 23.4 1 51 1z"
        />
    </svg>
);

export const IconUpdated: FC<TIconProps> = ({
    width = '56',
    height = '57',
    className = '',
    fillColor = '#696C74',
    onClick = () => {},
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 56 57">
            <g fill="none" fillRule="evenodd">
                <path d="M0 1h56v56H0z" />
                <path
                    d="M13.5 43a.5.5 0 110 1h-5a.5.5 0 110-1h5zm0 1h-5a.5.5 0 100-1h5a.5.5 0 100 1zm28-31a.5.5 0 01-.09-.992L41.5 12h5a.5.5 0 110 1h-5z"
                    fill="#696C74"
                    fillRule="nonzero"
                />
                <path
                    d="M14 43.5a.5.5 0 11-1 0v-5a.5.5 0 111 0v5zm-1 0v-5a.5.5 0 101 0v5a.5.5 0 10-1 0zm28-31a.5.5 0 111 0v5a.5.5 0 11-1 0v-5zm1 0v5a.5.5 0 10-1 0v-5a.5.5 0 101 0zM18.862 30.518l1.135 1.4 1.09 1.36c.355.447.703.887 1.044 1.32 2.02 2.568 3.884 2.518 6.058-.04l8.941-10.483a.5.5 0 00-.76-.65l-8.944 10.486c-1.777 2.092-2.894 2.122-4.51.069a312.15 312.15 0 00-3.278-4.093.5.5 0 10-.776.631z"
                    fill={fillColor}
                    fillRule="nonzero"
                />
                <path
                    d="M41.743 13.385c6.77 6.477 8.317 16.829 3.567 25.056-5.66 9.805-18.2 13.164-28.004 7.503a.5.5 0 10-.5.866c10.283 5.937 23.433 2.414 29.37-7.87 4.982-8.628 3.36-19.484-3.742-26.277a.5.5 0 10-.691.722zm-28.51 29.286a20.505 20.505 0 01-2.756-24.234C16.14 8.63 28.673 5.27 38.481 10.933a.5.5 0 10.5-.866c-10.286-5.938-23.432-2.415-29.37 7.87a21.505 21.505 0 002.891 25.417.5.5 0 00.731-.683z"
                    fill={fillColor}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};

export const IconEnvelope: FC<TIconProps> = ({
    width = '56',
    height = '56',
    className = '',
    fillColor = '#696C74',
    onClick = () => {},
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 56 56">
            <g fill="none">
                <path
                    d="M13.495 19.668l3.979 3.225 5.202 4.249c1.265 1.04 2.288 1.889 3.016 2.506 1.973 1.67 4.628 1.666 6.61.004l.965-.804 2.11-1.743 3.102-2.54 6.377-5.184a.5.5 0 01.63.777l-3.915 3.178-4.863 3.97-2.801 2.31c-.351.292-.673.56-.962.803-2.355 1.973-5.553 1.977-7.899-.008L23.838 29.4a422.532 422.532 0 00-1.565-1.294l-2.698-2.211-2.732-2.225-3.976-3.223a.5.5 0 01.628-.778z"
                    fill={fillColor}
                />
                <path
                    d="M41.783 11.5c5.912 0 8.717 2.795 8.717 8.717v14.609c0 5.912-2.795 8.717-8.717 8.717H16.217c-5.912 0-8.717-2.795-8.717-8.717V20.217c0-5.912 2.795-8.717 8.717-8.717h25.566zm0 1H16.217c-5.369 0-7.717 2.356-7.717 7.717v14.609c0 5.369 2.356 7.717 7.717 7.717h25.566c5.369 0 7.717-2.356 7.717-7.717V20.217c0-5.369-2.356-7.717-7.717-7.717z"
                    fill={fillColor}
                />
            </g>
        </svg>
    );
};

export const IconEnvelope2: FC<TIconProps> = ({ width = '86', height = '86', fillColor = '#88EBBE' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 86 86" fill="none">
            <path
                d="M73.7289 19.129H11.6759C9.22292 19.129 7.23438 21.1175 7.23438 23.5705V61.3995C7.23438 63.8525 9.22293 65.8411 11.6759 65.8411H73.7289C76.1819 65.8411 78.1705 63.8525 78.1705 61.3995V23.5705C78.1705 21.1175 76.1819 19.129 73.7289 19.129Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5449 28.8751L38.1795 44.8226C40.8493 46.7084 44.4174 46.7084 47.0872 44.8226L69.7318 28.87"
                fill={fillColor}
            />
            <path
                d="M15.5449 28.8751L38.1795 44.8226V44.8226C40.8493 46.7084 44.4174 46.7084 47.0872 44.8226V44.8226L69.7318 28.87"
                stroke="#045944"
                strokeWidth="2.22077"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const IconEnvelope3: FC<TIconProps> = ({ width = '73', height = '53', fillColor = '#2d2d2d' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 73 53" fill="none">
            <path
                d="M9.69572 0.111084C4.72472 0.111084 0.652222 4.18357 0.652222 9.15456V43.0676C0.652222 48.0386 4.72472 52.1111 9.69572 52.1111H63.9565C68.9275 52.1111 73 48.0386 73 43.0676V9.15456C73 4.18357 68.9275 0.111084 63.9565 0.111084H9.69572ZM9.69572 4.63282H63.9565C66.5007 4.63282 68.4783 6.61041 68.4783 9.15456V43.0676C68.4783 45.6118 66.5007 47.5893 63.9565 47.5893H9.69572C7.15152 47.5893 5.17392 45.6118 5.17392 43.0676V9.15456C5.17392 6.61041 7.15152 4.63282 9.69572 4.63282ZM15.1005 11.3801C14.6695 11.4221 14.2597 11.5869 13.9197 11.8549C13.5797 12.123 13.3238 12.483 13.1824 12.8923C13.0411 13.3015 13.0202 13.7428 13.1222 14.1636C13.2243 14.5844 13.445 14.967 13.7582 15.266L25.1331 26.5704L13.8287 36.8502C13.6084 37.0497 13.4295 37.2907 13.3022 37.5593C13.175 37.8279 13.1019 38.119 13.0871 38.4159C13.0724 38.7128 13.1162 39.0097 13.2162 39.2896C13.3162 39.5695 13.4703 39.827 13.6698 40.0474C13.8693 40.2677 14.1102 40.4466 14.3789 40.5739C14.6475 40.7011 14.9386 40.7742 15.2354 40.7889C15.5323 40.8037 15.8292 40.7598 16.1091 40.6598C16.389 40.5599 16.6465 40.4058 16.8669 40.2063L28.3478 29.7497L31.7744 33.141C34.5458 35.8906 39.07 35.8842 41.8424 33.141L45.2691 29.7497L56.7853 40.2063C57.0056 40.4058 57.2631 40.5599 57.5431 40.6598C57.823 40.7598 58.1199 40.8037 58.4167 40.7889C58.7136 40.7742 59.0047 40.7011 59.2733 40.5739C59.5419 40.4466 59.7829 40.2677 59.9824 40.0474C60.1818 39.827 60.336 39.5695 60.436 39.2896C60.5359 39.0097 60.5798 38.7128 60.565 38.4159C60.5503 38.119 60.4772 37.8279 60.3499 37.5593C60.2227 37.2907 60.0438 37.0497 59.8234 36.8502L48.4837 26.535L59.894 15.266C60.1121 15.0589 60.2868 14.8103 60.4077 14.5348C60.5286 14.2594 60.5933 13.9626 60.598 13.6618C60.6028 13.361 60.5475 13.0623 60.4353 12.7831C60.3232 12.504 60.1564 12.2501 59.9449 12.0362C59.7334 11.8223 59.4813 11.6528 59.2034 11.5376C58.9255 11.4223 58.6274 11.3637 58.3266 11.3651C58.0258 11.3665 57.7283 11.4279 57.4515 11.5457C57.1747 11.6635 56.9242 11.8354 56.7147 12.0513L38.6278 29.9263C37.794 30.7513 35.7831 30.7494 34.9539 29.9263L16.9374 12.0513C16.701 11.8091 16.4132 11.623 16.0953 11.5069C15.7774 11.3907 15.4374 11.3474 15.1005 11.3801Z"
                fill={fillColor}
            />
        </svg>
    );
};

export const IconAlert: FC<TIconProps> = ({
    width = '104px',
    height = '104px',
    onClick = () => {},
    className = '',
    fillColor = '#FF3200',
}) => (
    <svg width={width} height={height} onClick={onClick} className={className} viewBox="0 0 104 104">
        <g fill="none" fillRule="evenodd" stroke={fillColor}>
            <path
                stroke={fillColor}
                strokeWidth="2"
                d="M53.1633119,17.6591118 L20.5794508,82.2715734 C20.16956,83.08437 20.4269058,83.5 21.3454797,83.5 L85.8970964,83.5 C86.8163266,83.5 87.0732965,83.084926 86.6631254,82.2715734 L54.0792642,17.6591118 C53.7029475,16.9128911 53.5396379,16.9128728 53.1633119,17.6591118 Z"
            />
            <path
                stroke={fillColor}
                strokeLinecap="round"
                strokeWidth="2"
                d="M53.625 63.375L53.625 43.875M53.625 73.125L53.625 69.875"
            />
        </g>
    </svg>
);

export const IconBoxArrow: FC<TIconProps> = ({
    width = '16px',
    height = '16px',
    onClick = () => {},
    className = '',
    fillColor = '#36B4C7',
}) => (
    <svg width={width} height={height} onClick={onClick} className={className} viewBox="0 0 16 16">
        <g stroke={fillColor} fill="none" fillRule="evenodd">
            <path d="M7 9c5.429-5.333 8.094-8 7.997-8" strokeLinecap="square" />
            <path d="M6.862.5h8.633v8.633M5.086 3.5H.5v12h12V11" />
        </g>
    </svg>
);

export const IconCircleExclamationMinimal: FC<TIconProps> = ({
    width = '56px',
    height = '56px',
    className = '',
    fillColor = '#696C74',
}) => {
    return (
        <svg width={width} height={height} className={className} viewBox="0 0 56 56">
            <g transform="translate(7 6)" stroke={fillColor} fill="none" fillRule="evenodd">
                <path
                    d="M21.375 42.75C9.567 42.75 0 33.181 0 21.375S9.567 0 21.375 0C33.178 0 42.75 9.569 42.75 21.375S33.178 42.75 21.375 42.75z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="21.375" cy="30.281" r="1" />
                <path d="M21.375 23.156V12.47" strokeLinecap="round" />
            </g>
        </svg>
    );
};

export const IconAppleAppStore: FC<TIconProps> = ({
    width = '135px',
    height = '40px',
    className = '',
    fillColor = '#696C74',
}) => {
    return (
        <svg width={width} height={height} viewBox={'0 0 135 40'}>
            <path
                fill="#A6A6A6"
                d="M130.197 40H4.729A4.74 4.74 0 010 35.267V4.726A4.733 4.733 0 014.729 0h125.468C132.803 0 135 2.12 135 4.726v30.541c0 2.605-2.197 4.733-4.803 4.733z"
            />
            <path d="M134.032 35.268a3.83 3.83 0 01-3.834 3.83H4.729a3.835 3.835 0 01-3.839-3.83V4.725A3.84 3.84 0 014.729.89h125.468a3.834 3.834 0 013.834 3.835l.001 30.543z" />
            <g fill="#FFF">
                <path d="M30.128 19.784c-.029-3.223 2.639-4.791 2.761-4.864-1.511-2.203-3.853-2.504-4.676-2.528-1.967-.207-3.875 1.177-4.877 1.177-1.022 0-2.565-1.157-4.228-1.123-2.14.033-4.142 1.272-5.24 3.196-2.266 3.923-.576 9.688 1.595 12.859 1.086 1.553 2.355 3.287 4.016 3.226 1.625-.067 2.232-1.036 4.193-1.036 1.943 0 2.513 1.036 4.207.997 1.744-.028 2.842-1.56 3.89-3.127 1.255-1.78 1.759-3.533 1.779-3.623-.041-.014-3.387-1.291-3.42-5.154zM26.928 10.306c.874-1.093 1.472-2.58 1.306-4.089-1.265.056-2.847.875-3.758 1.944-.806.942-1.526 2.486-1.34 3.938 1.421.106 2.88-.717 3.792-1.793z" />
            </g>
            <g fill="#FFF">
                <path d="M53.645 31.504h-2.271l-1.244-3.909h-4.324l-1.185 3.909H42.41l4.284-13.308h2.646l4.305 13.308zm-3.89-5.549L48.63 22.48c-.119-.355-.342-1.191-.671-2.507h-.04a96.75 96.75 0 01-.632 2.507l-1.105 3.475h3.573zM64.662 26.588c0 1.632-.441 2.922-1.323 3.869-.79.843-1.771 1.264-2.942 1.264-1.264 0-2.172-.454-2.725-1.362h-.04v5.055H55.5V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.711-1.146 1.79-1.718 3.238-1.718 1.132 0 2.077.447 2.833 1.342.758.896 1.136 2.074 1.136 3.535zm-2.172.078c0-.934-.21-1.704-.632-2.31-.461-.632-1.08-.948-1.856-.948-.526 0-1.004.176-1.431.523-.428.35-.708.807-.839 1.373-.066.264-.099.48-.099.65v1.6c0 .698.214 1.287.642 1.768s.984.721 1.668.721c.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM75.699 26.588c0 1.632-.441 2.922-1.324 3.869-.789.843-1.77 1.264-2.941 1.264-1.264 0-2.172-.454-2.724-1.362h-.04v5.055h-2.132V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.71-1.146 1.789-1.718 3.238-1.718 1.131 0 2.076.447 2.834 1.342.755.896 1.134 2.074 1.134 3.535zm-2.172.078c0-.934-.211-1.704-.633-2.31-.461-.632-1.078-.948-1.855-.948a2.22 2.22 0 00-1.432.523c-.428.35-.707.807-.838 1.373-.065.264-.099.48-.099.65v1.6c0 .698.214 1.287.64 1.768.428.48.984.721 1.67.721.803 0 1.428-.31 1.875-.928.448-.619.672-1.435.672-2.449zM88.039 27.772c0 1.132-.393 2.053-1.182 2.764-.867.777-2.074 1.165-3.625 1.165-1.432 0-2.58-.276-3.449-.829l.494-1.777c.936.566 1.963.85 3.082.85.803 0 1.428-.182 1.877-.544.447-.362.67-.848.67-1.454 0-.54-.184-.995-.553-1.364-.367-.369-.98-.712-1.836-1.029-2.33-.869-3.494-2.142-3.494-3.816 0-1.094.408-1.991 1.225-2.689.814-.699 1.9-1.048 3.258-1.048 1.211 0 2.217.211 3.02.632l-.533 1.738c-.75-.408-1.598-.612-2.547-.612-.75 0-1.336.185-1.756.553a1.58 1.58 0 00-.533 1.205c0 .526.203.961.611 1.303.355.316 1 .658 1.936 1.027 1.145.461 1.986 1 2.527 1.618.539.616.808 1.387.808 2.307zM95.088 23.508h-2.35v4.659c0 1.185.414 1.777 1.244 1.777.381 0 .697-.033.947-.099l.059 1.619c-.42.157-.973.236-1.658.236-.842 0-1.5-.257-1.975-.77-.473-.514-.711-1.376-.711-2.587v-4.837h-1.4v-1.6h1.4v-1.757l2.094-.632v2.389h2.35v1.602zM105.691 26.627c0 1.475-.422 2.686-1.264 3.633-.883.975-2.055 1.461-3.516 1.461-1.408 0-2.529-.467-3.365-1.401s-1.254-2.113-1.254-3.534c0-1.487.43-2.705 1.293-3.652.861-.948 2.023-1.422 3.484-1.422 1.408 0 2.541.467 3.396 1.402.818.907 1.226 2.078 1.226 3.513zm-2.212.069c0-.885-.189-1.644-.572-2.277-.447-.766-1.086-1.148-1.914-1.148-.857 0-1.508.383-1.955 1.148-.383.634-.572 1.405-.572 2.317 0 .885.189 1.644.572 2.276.461.766 1.105 1.148 1.936 1.148.814 0 1.453-.39 1.914-1.168.393-.645.591-1.412.591-2.296zM112.621 23.783a3.702 3.702 0 00-.672-.059c-.75 0-1.33.283-1.738.85-.355.5-.533 1.132-.533 1.895v5.035h-2.131l.02-6.574c0-1.106-.027-2.113-.08-3.021h1.857l.078 1.836h.059c.225-.631.58-1.139 1.066-1.52a2.578 2.578 0 011.541-.514c.197 0 .375.014.533.039v2.033zM122.156 26.252a5 5 0 01-.078.967h-6.396c.025.948.334 1.673.928 2.173.539.447 1.236.671 2.092.671.947 0 1.811-.151 2.588-.454l.334 1.48c-.908.396-1.98.593-3.217.593-1.488 0-2.656-.438-3.506-1.313-.848-.875-1.273-2.05-1.273-3.524 0-1.447.395-2.652 1.186-3.613.828-1.026 1.947-1.539 3.355-1.539 1.383 0 2.43.513 3.141 1.539.563.815.846 1.823.846 3.02zm-2.033-.553c.014-.632-.125-1.178-.414-1.639-.369-.593-.936-.889-1.699-.889-.697 0-1.264.289-1.697.869-.355.461-.566 1.014-.631 1.658h4.441z" />
            </g>
            <g fill="#FFF">
                <path d="M49.05 10.009c0 1.177-.353 2.063-1.058 2.658-.653.549-1.581.824-2.783.824-.596 0-1.106-.026-1.533-.078V6.982c.557-.09 1.157-.136 1.805-.136 1.145 0 2.008.249 2.59.747.652.563.979 1.368.979 2.416zm-1.105.029c0-.763-.202-1.348-.606-1.756-.404-.407-.994-.611-1.771-.611-.33 0-.611.022-.844.068v4.889c.129.02.365.029.708.029.802 0 1.421-.223 1.857-.669s.656-1.096.656-1.95zM54.909 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.009.718-1.727.718-.692 0-1.243-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.712-.698c.692 0 1.248.229 1.669.688.4.446.601 1.022.601 1.726zm-1.087.034c0-.435-.094-.808-.281-1.119-.22-.376-.533-.564-.94-.564-.421 0-.741.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .714-.191.94-.574.194-.317.291-.693.291-1.128zM62.765 8.719l-1.475 4.714h-.96l-.611-2.047a15.32 15.32 0 01-.379-1.523h-.019a11.15 11.15 0 01-.379 1.523l-.649 2.047h-.971l-1.387-4.714h1.077l.533 2.241c.129.53.235 1.035.32 1.513h.019c.078-.394.207-.896.389-1.503l.669-2.25h.854l.641 2.202c.155.537.281 1.054.378 1.552h.029c.071-.485.178-1.002.32-1.552l.572-2.202h1.029zM68.198 13.433H67.15v-2.7c0-.832-.316-1.248-.95-1.248a.946.946 0 00-.757.343 1.217 1.217 0 00-.291.808v2.796h-1.048v-3.366c0-.414-.013-.863-.038-1.349h.921l.049.737h.029c.122-.229.304-.418.543-.569.284-.176.602-.265.95-.265.44 0 .806.142 1.097.427.362.349.543.87.543 1.562v2.824zM71.088 13.433h-1.047V6.556h1.047v6.877zM77.258 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.01.718-1.727.718-.693 0-1.244-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.711-.698c.693 0 1.248.229 1.67.688.4.446.601 1.022.601 1.726zm-1.088.034c0-.435-.094-.808-.281-1.119-.219-.376-.533-.564-.939-.564-.422 0-.742.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .713-.191.939-.574.195-.317.291-.693.291-1.128zM82.33 13.433h-.941l-.078-.543h-.029c-.322.433-.781.65-1.377.65-.445 0-.805-.143-1.076-.427a1.339 1.339 0 01-.369-.96c0-.576.24-1.015.723-1.319.482-.304 1.16-.453 2.033-.446V10.3c0-.621-.326-.931-.979-.931-.465 0-.875.117-1.229.349l-.213-.688c.438-.271.979-.407 1.617-.407 1.232 0 1.85.65 1.85 1.95v1.736c0 .471.023.846.068 1.124zm-1.088-1.62v-.727c-1.156-.02-1.734.297-1.734.95 0 .246.066.43.201.553a.733.733 0 00.512.184c.23 0 .445-.073.641-.218a.893.893 0 00.38-.742zM88.285 13.433h-.93l-.049-.757h-.029c-.297.576-.803.864-1.514.864-.568 0-1.041-.223-1.416-.669s-.562-1.025-.562-1.736c0-.763.203-1.381.611-1.853.395-.44.879-.66 1.455-.66.633 0 1.076.213 1.328.64h.02V6.556h1.049v5.607c0 .459.012.882.037 1.27zm-1.086-1.988v-.786a1.194 1.194 0 00-.408-.965 1.03 1.03 0 00-.701-.257c-.391 0-.697.155-.922.466-.223.311-.336.708-.336 1.193 0 .466.107.844.322 1.135.227.31.533.465.916.465.344 0 .619-.129.828-.388.202-.239.301-.527.301-.863zM97.248 11.037c0 .725-.207 1.319-.621 1.785-.434.479-1.008.718-1.727.718-.691 0-1.242-.229-1.654-.689-.41-.459-.615-1.038-.615-1.736 0-.73.211-1.329.635-1.794s.994-.698 1.713-.698c.691 0 1.248.229 1.668.688.4.446.601 1.022.601 1.726zm-1.086.034c0-.435-.094-.808-.281-1.119-.221-.376-.533-.564-.941-.564-.42 0-.74.188-.961.564-.188.311-.281.69-.281 1.138 0 .435.094.808.281 1.119.227.376.543.564.951.564.4 0 .715-.191.941-.574.193-.317.291-.693.291-1.128zM102.883 13.433h-1.047v-2.7c0-.832-.316-1.248-.951-1.248-.311 0-.562.114-.756.343s-.291.499-.291.808v2.796h-1.049v-3.366c0-.414-.012-.863-.037-1.349h.92l.049.737h.029a1.53 1.53 0 01.543-.569c.285-.176.602-.265.951-.265.439 0 .805.142 1.096.427.363.349.543.87.543 1.562v2.824zM109.936 9.504h-1.154v2.29c0 .582.205.873.611.873.188 0 .344-.016.467-.049l.027.795c-.207.078-.479.117-.814.117-.414 0-.736-.126-.969-.378-.234-.252-.35-.676-.35-1.271V9.504h-.689v-.785h.689v-.864l1.027-.31v1.173h1.154v.786zM115.484 13.433h-1.049v-2.68c0-.845-.316-1.268-.949-1.268-.486 0-.818.245-1 .735a1.317 1.317 0 00-.049.377v2.835h-1.047V6.556h1.047v2.841h.02c.33-.517.803-.775 1.416-.775.434 0 .793.142 1.078.427.355.355.533.883.533 1.581v2.803zM121.207 10.853c0 .188-.014.346-.039.475h-3.143c.014.466.164.821.455 1.067.266.22.609.33 1.029.33.465 0 .889-.074 1.271-.223l.164.728c-.447.194-.973.291-1.582.291-.73 0-1.305-.215-1.721-.645-.418-.43-.625-1.007-.625-1.731 0-.711.193-1.303.582-1.775.406-.504.955-.756 1.648-.756.678 0 1.193.252 1.541.756.281.4.42.895.42 1.483zm-1-.271a1.411 1.411 0 00-.203-.805c-.182-.291-.459-.437-.834-.437a.995.995 0 00-.834.427 1.586 1.586 0 00-.311.815h2.182z" />
            </g>
        </svg>
    );
};

export const IconGoogleAppStore: FC<TIconProps> = ({
    width = '5435px',
    height = '1604px',
    className = '',
    fillColor = '#696C74',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 5435.8 1604">
            <path
                d="M5234.4 1604h-5033C90.4 1604 0 1513.6 0 1403.5v-1203C0 90 90.4 0 201.4 0h5033c110.9 0 201.4 90 201.4 200.5v1203c0 110.1-90.5 200.5-201.4 200.5z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M5234.4 32.1c93.1 0 169.3 75.7 169.3 168.4v1203c0 92.7-75.7 168.4-169.3 168.4h-5033c-93.1 0-169.3-75.7-169.3-168.4v-1203c0-92.7 75.7-168.4 169.3-168.4h5033zm0-32.1h-5033C90.4 0 0 90.4 0 200.5v1203C0 1514 90.4 1604 201.4 1604h5033c110.9 0 201.4-90 201.4-200.5v-1203C5435.8 90.4 5345.3 0 5234.4 0z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#a6a6a6"
            />
            <path
                d="M2863.6 530.6c-36.3 0-66.9-12.7-91.1-37.7-24-24.3-37.4-57.8-36.8-92 0-36.5 12.4-67.4 36.8-91.9 24.1-25 54.7-37.7 91-37.7 35.9 0 66.5 12.7 91.1 37.7 24.4 25.3 36.8 56.2 36.8 91.9-.4 36.6-12.8 67.5-36.8 91.9-24.1 25.2-54.7 37.8-91 37.8zm-1080.1 0c-35.5 0-66.3-12.5-91.5-37.2-25-24.6-37.7-55.7-37.7-92.4s12.7-67.8 37.7-92.4c24.7-24.7 55.5-37.2 91.5-37.2 17.6 0 34.7 3.5 51.1 10.6 16.1 6.9 29.2 16.3 38.9 27.8l2.4 2.9-27.1 26.6-2.8-3.3c-15.3-18.2-35.8-27.1-62.9-27.1-24.2 0-45.3 8.6-62.7 25.6-17.5 17.1-26.4 39.5-26.4 66.6s8.9 49.5 26.4 66.6c17.4 17 38.5 25.6 62.7 25.6 25.8 0 47.5-8.6 64.4-25.6 10-10 16.2-24 18.4-41.7H1779v-37.4h124.2l.5 3.4c.9 6.3 1.8 12.8 1.8 18.8 0 34.5-10.4 62.4-31 83-23.4 24.4-54 36.8-91 36.8zm1436.1-5.3h-38.3L3064 337.6l1 33.8v153.8h-38.3V276.7h43.7l1.2 1.9 110.3 176.8-1-33.7v-145h38.7v248.6zm-643.8 0H2537V314.1h-67.3v-37.4H2643v37.4h-67.3v211.2zm-137.7 0h-38.7V276.7h38.7v248.6zm-217.5 0h-38.7V314.1h-67.3v-37.4h173.3v37.4h-67.3v211.2zm-130.5-.4h-148.4V276.7h148.4v37.4h-109.6v68.2h98.9v37h-98.9v68.2h109.6v37.4zm710.8-57.7c17.3 17.3 38.3 26 62.7 26 25.1 0 45.6-8.5 62.7-26 17-17 25.6-39.3 25.6-66.2s-8.6-49.3-25.5-66.2c-17.3-17.3-38.4-26-62.7-26-25.1 0-45.6 8.5-62.6 26-17 17-25.6 39.3-25.6 66.2s8.5 49.3 25.4 66.2z"
                fill="#fff"
            />
            <path
                d="M2732.1 872.4c-94.5 0-171.1 71.7-171.1 170.6 0 98 77.1 170.6 171.1 170.6 94.5 0 171.1-72.2 171.1-170.6 0-98.9-76.6-170.6-171.1-170.6zm0 273.6c-51.7 0-96.2-42.8-96.2-103.4 0-61.5 44.6-103.4 96.2-103.4 51.7 0 96.2 41.9 96.2 103.4.1 61-44.5 103.4-96.2 103.4zm-373.3-273.6c-94.5 0-171.1 71.7-171.1 170.6 0 98 77.1 170.6 171.1 170.6 94.5 0 171.1-72.2 171.1-170.6 0-98.9-76.7-170.6-171.1-170.6zm0 273.6c-51.7 0-96.2-42.8-96.2-103.4 0-61.5 44.6-103.4 96.2-103.4 51.7 0 96.2 41.9 96.2 103.4 0 61-44.5 103.4-96.2 103.4zm-444.2-221.5v72.2h173.3c-5.3 40.5-18.7 70.4-39.2 90.9-25.4 25.4-64.6 53-133.7 53-106.5 0-189.8-86-189.8-192.5s83.3-192.5 189.8-192.5c57.5 0 99.4 22.7 130.5 51.7l51.2-51.2c-43.2-41.4-100.7-73.1-181.3-73.1-146.1 0-268.7 119-268.7 264.7 0 146.1 122.5 264.7 268.7 264.7 78.9 0 138.1-25.8 184.9-74.4 47.7-47.7 62.8-115 62.8-169.3 0-16.9-1.3-32.1-4-45h-244.6c.1-.1.1.8.1.8zm1816.9 56.2C3717.2 942.4 3674 872 3585.4 872c-87.8 0-160.8 69.1-160.8 170.6 0 95.8 72.2 170.6 169.3 170.6 78 0 123.4-47.7 142.1-75.7l-57.9-38.8c-19.2 28.5-45.9 47.2-83.8 47.2-38.3 0-65.1-17.4-82.9-51.7l228.1-94.5c0 .1-8-19-8-19zm-232.6 57c-1.8-65.9 51.2-99.4 89.1-99.4 29.9 0 54.8 14.7 63.3 36.1l-152.4 63.3zM3313.6 1203h74.9V701.8h-74.9V1203zm-123-292.7h-2.7c-16.9-20.1-49-38.3-90-38.3-85.1 0-163.5 74.9-163.5 171.1 0 95.8 78 169.8 163.5 169.8 40.5 0 73.1-18.3 90-38.8h2.7v24.5c0 65.1-34.8 100.2-90.9 100.2-45.9 0-74.4-33-86-60.6l-65.1 27.2c18.7 45 68.6 100.7 151 100.7 87.8 0 162.2-51.7 162.2-177.8V882.2H3191v28.1h-.4zm-86 235.7c-51.7 0-94.9-43.2-94.9-102.9 0-60.2 43.2-103.8 94.9-103.8 51.2 0 90.9 44.1 90.9 103.8.5 59.7-39.6 102.9-90.9 102.9zm977.6-444.2h-179.1V1203h74.9v-189.8h104.3c82.9 0 164.4-60.1 164.4-155.5s-81.2-155.9-164.5-155.9zm2.2 241.4h-106.5v-172h106.5c56.1 0 87.8 46.3 87.8 86 0 39.3-32.1 86-87.8 86zm462.5-71.7c-54.4 0-110.5 24.1-133.7 76.6l66.4 27.6c14.3-27.6 40.5-37 68.2-37 38.8 0 78 23.2 78.9 64.6v5.3c-13.4-7.6-42.8-19.2-78-19.2-71.7 0-144.4 39.2-144.4 112.7 0 67.3 58.8 110.5 124.3 110.5 50.3 0 78-22.7 95.3-49h2.7v38.8h72.2v-192c0-89.4-66.4-138.9-151.9-138.9zm-9.4 274.5c-24.5 0-58.8-12-58.8-42.8 0-38.8 42.8-53.5 79.3-53.5 33 0 48.6 7.1 68.2 16.9-5.4 45-43.4 79-88.7 79.4zm424.7-263.8l-86 217.4h-2.7l-89.1-217.4h-80.6l133.7 303.9-76.2 168.9h78L5045 882.2h-82.8zM4288 1203h74.9V701.8H4288V1203z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#fff"
            />
            <linearGradient
                id="a"
                gradientUnits="userSpaceOnUse"
                x1="1682.108"
                y1="1339.478"
                x2="1624.292"
                y2="1309.634"
                gradientTransform="matrix(11.64 0 0 -22.55 -18705.596 30554.37)"
            >
                <stop offset="0" stopColor="#00a0ff" />
                <stop offset=".007" stopColor="#00a1ff" />
                <stop offset=".26" stopColor="#00beff" />
                <stop offset=".512" stopColor="#00d2ff" />
                <stop offset=".76" stopColor="#00dfff" />
                <stop offset="1" stopColor="#00e3ff" />
            </linearGradient>
            <path
                d="M418.4 302.1c-11.6 12.5-18.3 31.6-18.3 56.6v886.7c0 25 6.7 44.1 18.7 56.1l3.1 2.7 496.8-496.8v-11.1L421.5 299.4l-3.1 2.7z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="url(#a)"
            />
            <linearGradient
                id="b"
                gradientUnits="userSpaceOnUse"
                x1="1712.662"
                y1="1274.838"
                x2="1606.561"
                y2="1274.838"
                gradientTransform="matrix(9.145 0 0 -7.7 -14305.538 10618.251)"
            >
                <stop offset="0" stopColor="#ffe000" />
                <stop offset=".409" stopColor="#ffbd00" />
                <stop offset=".775" stopColor="orange" />
                <stop offset="1" stopColor="#ff9c00" />
            </linearGradient>
            <path
                d="M1084 973.5L918.3 807.8v-11.6L1084 630.5l3.6 2.2 196 111.4c56.1 31.6 56.1 83.8 0 115.8l-196 111.4-3.6 2.2z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="url(#b)"
            />
            <linearGradient
                id="c"
                gradientUnits="userSpaceOnUse"
                x1="1707.441"
                y1="1290.047"
                x2="1646.682"
                y2="1211.223"
                gradientTransform="matrix(15.02 0 0 -11.5775 -24650.229 15829.648)"
            >
                <stop offset="0" stopColor="#ff3a44" />
                <stop offset="1" stopColor="#c31162" />
            </linearGradient>
            <path
                d="M1087.6 971.3L918.3 802l-499.9 499.9c18.3 19.6 49 21.8 83.3 2.7l585.9-333.3"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="url(#c)"
            />
            <linearGradient
                id="d"
                gradientUnits="userSpaceOnUse"
                x1="1660.636"
                y1="1365.668"
                x2="1687.767"
                y2="1330.45"
                gradientTransform="matrix(15.02 0 0 -11.5715 -24650.229 15809.992)"
            >
                <stop offset="0" stopColor="#32a071" />
                <stop offset=".069" stopColor="#2da771" />
                <stop offset=".476" stopColor="#15cf74" />
                <stop offset=".801" stopColor="#06e775" />
                <stop offset="1" stopColor="#00f076" />
            </linearGradient>
            <path
                d="M1087.6 632.7L501.7 299.9c-34.3-19.6-65.1-16.9-83.3 2.7L918.3 802l169.3-169.3z"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="url(#d)"
            />
            <path
                d="M1084 967.7l-581.9 330.6c-32.5 18.7-61.5 17.4-80.2.4l-3.1 3.1 3.1 2.7c18.7 16.9 47.7 18.3 80.2-.4L1088 971.3l-4-3.6z"
                opacity=".2"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M1283.6 854.1l-200.1 113.6 3.6 3.6 196-111.4c28.1-16 41.9-37 41.9-57.9-1.7 19.2-16 37.4-41.4 52.1z"
                opacity=".12"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M501.7 305.7l781.9 444.2c25.4 14.3 39.7 33 41.9 52.1 0-20.9-13.8-41.9-41.9-57.9L501.7 299.9c-56.1-32.1-101.6-5.3-101.6 58.8v5.8c0-64.2 45.5-90.5 101.6-58.8z"
                opacity=".25"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#fff"
            />
        </svg>
    );
};

export const IconGoogle: FC<TIconProps> = ({ width = '18px', height = '18px' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 43 44">
            <g>
                <path
                    d="M9 22a13.06 13.06 0 0 1 .66-4.08l-7.4-5.67a22.18 22.18 0 0 0 0 19.49l7.4-5.67A13 13 0 0 1 9 22z"
                    fill="#fbbc05"
                />
                <path
                    d="M22 9a12.72 12.72 0 0 1 8.1 2.9l6.4-6.4a22 22 0 0 0-34.24 6.75l7.4 5.67A13 13 0 0 1 22 9z"
                    fill="#ea4335"
                />
                <path
                    d="M22 35a13 13 0 0 1-12.35-8.93l-7.4 5.67A21.93 21.93 0 0 0 22 44a20.94 20.94 0 0 0 14.33-5.48l-7-5.44A13.62 13.62 0 0 1 22 35z"
                    fill="#34a853"
                />
                <path
                    d="M22 18v8.5h11.8a9.93 9.93 0 0 1-4.49 6.58l7 5.44C40.37 34.76 43 29.17 43 22a18.25 18.25 0 0 0-.5-4z"
                    fill="#4285f4"
                />
            </g>
        </svg>
    );
};

export const IconApple: FC<TIconProps> = ({ width = '18px', height = '18px' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 1000 1187">
            <path d="M979.042 925.188c-17.954 41.477-39.206 79.657-63.828 114.759-33.563 47.853-61.044 80.976-82.222 99.37-32.83 30.192-68.006 45.654-105.672 46.533-27.041 0-59.652-7.694-97.611-23.303-38.085-15.536-73.084-23.23-105.086-23.23-33.563 0-69.56 7.694-108.061 23.23-38.561 15.609-69.625 23.743-93.376 24.55-36.12 1.538-72.123-14.364-108.06-47.78-22.938-20.006-51.627-54.302-85.997-102.888-36.875-51.883-67.191-112.047-90.942-180.639C12.751 781.703 0 709.96 0 640.504c0-79.562 17.192-148.183 51.627-205.687 27.063-46.19 63.066-82.625 108.127-109.373 45.06-26.748 93.749-40.378 146.182-41.25 28.69 0 66.312 8.874 113.066 26.315 46.622 17.5 76.557 26.374 89.682 26.374 9.812 0 43.068-10.376 99.443-31.064 53.313-19.185 98.307-27.129 135.168-24 99.883 8.062 174.923 47.436 224.828 118.372-89.33 54.126-133.52 129.936-132.64 227.188.806 75.751 28.287 138.788 82.295 188.84 24.476 23.23 51.81 41.183 82.222 53.934-6.595 19.127-13.557 37.447-20.958 55.035zM749.964 23.75c0 59.374-21.692 114.81-64.928 166.122-52.176 61-115.286 96.248-183.724 90.686a184.836 184.836 0 01-1.378-22.497c0-56.999 24.813-117.998 68.878-167.874 21.999-25.253 49.978-46.25 83.907-63 33.856-16.5 65.88-25.625 95.999-27.187.88 7.937 1.246 15.875 1.246 23.75z" />
        </svg>
    );
};

export const IconFacebook: FC<TIconProps> = ({ width = '18px', height = '18px' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24">
            <defs>
                <path id="a" d="M.001 0H20v19.862H.001z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <g transform="translate(2 2)">
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <path
                        d="M20 9.992C20 4.474 15.523 0 10 0S0 4.474 0 9.992c0 4.987 3.657 9.12 8.438 9.87V12.88h-2.54V9.992h2.54V7.79c0-2.505 1.492-3.888 3.777-3.888 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.77-1.63 1.56v1.874h2.773l-.443 2.888h-2.33v6.982c4.78-.75 8.437-4.883 8.437-9.87"
                        fill="#1877F2"
                        mask="url(#b)"
                    />
                </g>
                <path
                    d="M15.84 14.873l.443-2.898h-2.766v-1.88c0-.793.386-1.566 1.625-1.566H16.4V6.062s-1.142-.195-2.233-.195c-2.278 0-3.768 1.387-3.768 3.9v2.208H7.867v2.898h2.532v7.005a10.001 10.001 0 003.118 0v-7.005h2.324"
                    fill="#FFF"
                />
            </g>
        </svg>
    );
};

export const IconRemoveUser: FC<TIconProps> = ({ width = '86', height = '86' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 86 86" fill="none">
            <path
                d="M49.1039 28.5909C50.0237 22.9244 46.1758 17.5852 40.5093 16.6654C34.8428 15.7456 29.5036 19.5935 28.5838 25.26C27.664 30.9265 31.512 36.2657 37.1784 37.1855C42.8449 38.1053 48.1841 34.2573 49.1039 28.5909Z"
                fill="#88EBBE"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M38.8318 39.6416C26.221 39.6416 15.9998 48.1985 15.9998 58.7494V62.9598C15.9998 63.1864 16.1851 63.3718 16.4117 63.3718H61.2478C61.4744 63.3718 61.6598 63.1864 61.6598 62.9598V58.7494C61.6598 48.1944 51.4385 39.6416 38.8277 39.6416H38.8318Z"
                fill="#88EBBE"
            />
            <path
                d="M59.7402 71.2038C64.8573 71.2038 69.0056 67.0555 69.0056 61.9383C69.0056 56.8212 64.8573 52.6729 59.7402 52.6729C54.623 52.6729 50.4747 56.8212 50.4747 61.9383C50.4747 67.0555 54.623 71.2038 59.7402 71.2038Z"
                fill="#008363"
            />
            <path
                d="M55.1013 61.9385H64.3751"
                stroke="#EBF9F1"
                stroke-width="2.22077"
                stroke-miterlimit="10"
                stroke-linecap="round"
            />
        </svg>
    );
};

export const IconRemoveUserOutlined: FC<TIconProps> = ({ width = '49', height = '36', fillColor = '#000000' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 49 36.22">
            <path
                d="M18.67 17.5c2.57 0 4.67-.82 6.3-2.45 1.63-1.63 2.45-3.73 2.45-6.3s-.82-4.67-2.45-6.3C23.34.82 21.24 0 18.67 0s-4.67.82-6.3 2.45c-1.63 1.63-2.45 3.73-2.45 6.3s.82 4.67 2.45 6.3c1.63 1.63 3.73 2.45 6.3 2.45ZM14.91 4.99C15.9 4 17.15 3.5 18.67 3.5s2.77.5 3.76 1.49c.99.99 1.49 2.25 1.49 3.76s-.5 2.77-1.49 3.76S20.19 14 18.67 14s-2.77-.49-3.76-1.49c-.99-.99-1.49-2.25-1.49-3.76s.5-2.77 1.49-3.76ZM33.31 24.56c-2.92-1.28-5.5-2.19-7.76-2.71a30.03 30.03 0 0 0-6.89-.79c-2.33 0-4.65.26-6.91.79-2.27.52-4.86 1.43-7.78 2.71-1.28.54-2.27 1.37-2.95 2.48C.34 28.15 0 29.38 0 30.74v1.98c0 .96.34 1.79 1.03 2.47.68.69 1.51 1.03 2.47 1.03h30.33c.96 0 1.79-.34 2.47-1.03.68-.68 1.03-1.51 1.03-2.47v-1.98c0-1.36-.35-2.59-1.05-3.68-.7-1.09-1.69-1.92-2.97-2.51Zm.52 8.17H3.5v-1.98c0-.63.17-1.24.5-1.78.33-.56.79-.98 1.37-1.25 2.76-1.28 5.1-2.13 7.03-2.54 1.92-.41 4.01-.61 6.27-.61s4.34.2 6.24.61c1.9.41 4.24 1.25 7 2.54.58.27 1.07.71 1.4 1.25.35.57.52 1.16.52 1.78v1.98ZM48.5 10.95a1.69 1.69 0 0 0-1.25-.51H37.22c-.5 0-.91.17-1.25.5-.33.33-.5.74-.5 1.24-.01.47.17.92.5 1.25.34.34.75.51 1.25.51h10.03c.5 0 .91-.17 1.25-.5.34-.33.5-.74.5-1.24s-.17-.92-.5-1.26Z"
                fill={fillColor}
            />
        </svg>
    );
};
